import request from '@/utils/request'

// 查询参数列表
export function getStrategyPageList(params) {
  return request({
    url: '/mini/content/strategy/getStrategyPageList',
    method: 'post',
    data: params
  })
}

export function getStrategyCategoryPageList(params) {
  return request({
    url: '/mini/content/strategy/getStrategyCategoryPageList',
    method: 'post',
    data: params
  })
}

export function getStrategyDetail(strategyId) {
  return request({
    url: `/mini/content/strategy/${strategyId}`,
    method: 'get'
  })
}